module.exports = __webpack_public_path__ + "static/img/logon.002e161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logon.png
// module id = DGSa
// module chunks = 1